import { TagsCard } from '~/components/TagsCard';
import { useIsCorsoCxAgent } from '~/hooks/useIsCorsoAdmin';
import {
  useShippingClaimTags,
  useShippingClaimTagsUpsert,
  useStoreShippingClaimTags,
} from '~/hooks/useShippingClaimTags';

export function ShippingClaimTagDisplay() {
  const isCorsoCxAgent = useIsCorsoCxAgent();
  const { data: storeTags = [], isPending: isOptionsPending } =
    useStoreShippingClaimTags();
  const { data: currentTags = [], isPending: isCurrentPending } =
    useShippingClaimTags();
  const { mutateAsync: upsertTags, isPending: isUpsertPending } =
    useShippingClaimTagsUpsert();

  if (!isCorsoCxAgent) return null;
  return (
    <TagsCard
      storeTags={storeTags}
      currentTags={currentTags}
      isLoading={isOptionsPending || isCurrentPending}
      isSaving={isUpsertPending}
      onChange={(tagNames) => {
        upsertTags(tagNames).catch((error) => console.error(error));
      }}
    />
  );
}
